import { Col, Form, FormInstance, Row, Switch } from "antd";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import type { DataGridColDef } from "components/DataGrid/DataGrid";
import DataGrid from "components/theme_components/DataGrid";
import ButtonLink from "components/theme_components/ButtonLink";
import { AuthContext } from "components/Auth/Auth";
import ConfirmModal from "components/theme_components/ThirdParty/ConfirmModal";
import { setValueByNamePath } from "utils/utils2";
import { indexBy } from "utils/utilsSFS";
import { render } from "less";
import { toCurrency } from "utils/utils";

export type IntramarqueModalProps = {
  setVisible: (visible: boolean) => void;
  dataList: any[];
  onDone: any;
  onCancel: any;
  dataInput: any;
  form: FormInstance
  loading: boolean;
  tptype: string;
};

const TabIntraBrand = ({ setVisible, dataList, onDone, dataInput, form, loading, onCancel, tptype }: IntramarqueModalProps) => {
  const navigate = useNavigate();
  const { isInspect } = useContext(AuthContext);

  const [modalVisible, setModalVisible] = useState(false);
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);

  const fieldName = 'authList'


  useEffect(() => {
    if (dataList) {
      form.setFieldsValue({
        event: 'TabIntraBrand',
        [fieldName]: dataList,
        tptype: tptype
      })

      console.log('dataList', dataList)
    }

    if (dataInput) {
      form.setFieldsValue({
        authbrand: dataInput?.silobrand
      })
    }
  }, [tptype, dataInput]);


  const columns_authorzationList: any[] = [
    {
      dataIndex: "tpreference",
      comcode: "tprefersilo",
      className: "font-size-15",
      width: '8%',

    },
    {
      dataIndex: "tpname",
      className: "font-size-15 font-weight-500",
      width: '20%',
    },
    {
      dataIndex: "tpmainadrcity",
      sorter: true,
      className: "font-size-15",
      width: '10%',
    },
    {
      dataIndex: "authavailableamount",
      align: "right",
      render: (val: number) => toCurrency(val),
      className: "font-size-15",
      width: '10%',
    },
    {
      dataIndex: "pourcentageConsumedNLimit",
      align: "right",
      className: "font-size-15",
      width: '10%',
     
      render: (val: number) => val !== null && val !== undefined ? `${val}%` : '',
    },
    {
      dataIndex: "actions",
      align: "left",
      width: '7%',
      render: (_: any, record: any, index: number) => (
        <Form.Item name={[fieldName, index, 'flagexcludpermeabilitypm']} initialValue={record.flagexcludpermeabilitypm} noStyle>

          <Switch
            className="custom-switch"
            checked={record.flagexcludpermeabilitypm == false}
            onChange={(e) => {
              console.log('eeee', e)
              setValueByNamePath(
                form,
                [
                  fieldName,
                  index,
                  'flagexcludpermeabilitypm',
                ],
                !e
              );
            }}

          />
        </Form.Item>

      ),
    },
  ];

  return (
    <div>
      <Form.Item shouldUpdate>
        {({ getFieldValue, getFieldsValue }) => {
          console.log('fieldName', getFieldValue(fieldName));
          return (

            <DataGrid
              columns={columns_authorzationList}
              dataSource={getFieldValue(fieldName)}
              rowKey={(record) => record.id}
              pagination={{
                pageSize: 10,
                total: dataList?.length,
                showSizeChanger: true,
                showQuickJumper: false,
                showTotal: (total, range) => `${range[0]} - ${range[1]} sur ${total}`,
              }}
              hideFilters
              hideTitle
            />)
        }}
      </Form.Item>

      <Row justify="end" className="modal-footer" gutter={8}>
        <Col span={4} className="d-flex justify-end">
          <ButtonLink comcode="close" className="ut-btn-bordred mr-0"
            onClick={() => {
              !isInspect && onCancel()
            }} />
        </Col>
        <Col span={3}>
          <ButtonLink
            type="primary"
            comcode="Valider"
            htmlType="submit"
            className="submit-btn"
            onClick={() => {
              !isInspect && onDone();
            }}
            loading={loading}
          />
        </Col>
        <ConfirmModal
          visible={modalVisible}
          status="error"
          message="Le concessionnaire a un reste disponible négatif, souhaitez-vous réellement l’exclure du silo Citroën VN ?"
          onConfirm={() => {
            if (pendingAction) pendingAction();
          }}
          onCancel={() => setModalVisible(false)}
          onlyCancel
          onlyConfirm
          className='modalConfirmOrCancel'
        />
      </Row>
    </div>
  );
};

export default TabIntraBrand;
